export default "/list/static/images/vr_v2.svg";